export default __webpack_public_path__ + "static/media/Menu.eea52169.svg";